import { apiGet } from 'utils/http';

const settlementAPI = {
  fetchById: async ({ id }) => {
    return (await apiGet(`/settlements/${id}`)).settlement;
  },
  fetchPage: async ({ page, pageSize, filters }) => {
    return apiGet(`/settlements`, {
      query: {
        offset: page * pageSize,
        pageSize,
        ...filters,
      },
    });
  },
};

export { settlementAPI };
